/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { SVGProps } from 'react';

const FontAwesomeArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="FontAwesomeArrowDown">
    <path
      d="M9 12.172V0H7v12.172L1.636 6.808.222 8.222 8 16l7.778-7.778-1.414-1.414L9 12.172Z"
      fill="currentColor"
    />
  </svg>
);

export default FontAwesomeArrowDown;
